module.exports = __webpack_public_path__ + "static/receipts-book-wrapper-25a178cb5781635ee11ac0c90a0f823e.png";